import List from 'list.js';

document.addEventListener("DOMContentLoaded", function (e) {

	if(document.getElementById('countrySelect')) {

	    let countryList = new List('agency__list-container', {
	        valueNames: [ 'country' ]
	    });

	    let selectFilter = document.querySelector("#countrySelect");
	    selectFilter.addEventListener("change", filterBySelect, false);

	    function filterBySelect(event) {
	        let selected = event.target.selectedOptions[0];
	        let filter = selected.attributes["value"].value;

	        countryList.filter(function (item) {
	            if(filter === '') return true;
	            return item.values().country === filter;
	        });
	    }
	}

});
